import { db } from '../../../firebaseConfig';
import { getDocs, collection, query, where } from 'firebase/firestore/lite';

export const getSupplierDocument = async (supplierName) => {
  const collectionRef = collection(db, "supplier");
  const q = query(collectionRef,
    where('supplierName','==',supplierName));
  return getDocs(q);
};
